import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { mapTo } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NgxLangService {
  constructor(private translate: TranslateService) {}

  ready() {
    return this.translate.get('app_name').pipe(mapTo(true));
  }
}
